'use client';

import { useState, useCallback, useRef, useEffect } from 'react';
import { useAuth } from '@/components/auth/auth-provider';

export function useAuthGate() {
  const { user, isLoading } = useAuth();
  const [showAuthModal, setShowAuthModal] = useState(false);
  const pendingAction = useRef<(() => void) | null>(null);

  useEffect(() => {
    if (user && pendingAction.current) {
      const action = pendingAction.current;
      pendingAction.current = null;
      action();
    }
  }, [user]);

  const requireAuth = useCallback((onAuthenticated?: () => void): boolean => {
    if (isLoading) return false;
    if (user) return true;
    if (onAuthenticated) pendingAction.current = onAuthenticated;
    setShowAuthModal(true);
    return false;
  }, [user, isLoading]);

  return {
    isAuthenticated: !!user,
    showAuthModal,
    setShowAuthModal,
    requireAuth,
  };
}
